import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { Link } from "react-router-dom";

export const InspectionSection = ({
  title,
  subtitle,
  comments,
  notes,
  inspectionType,
  images,
  PifNumber,
  indexAlphabet,
  deficiencyFound,
}) => (
  <SoftBox
    p={2}
    display="flex"
    flexDirection="column"
   
    gap={0.5}
    backgroundColor="shadow.main"
  >
    <SoftBox>
      <SoftBox display="flex" gap={1}>
        <SoftTypography component="span" fontSize="16px" fontWeight="bold">
          {indexAlphabet && `${indexAlphabet}`} Deficiency Found :
        </SoftTypography>

        <SoftTypography
          fontSize="16px"
          fontWeight="regular"
          sx={{ textTransform: "capitalize" }}
        >
          {(deficiencyFound || [])
            ?.map((d) => d.replace(/_/g, " "))
            ?.join(", ")}
        </SoftTypography>
      </SoftBox>
      <SoftTypography fontSize="16px" fontWeight="regular">
        <SoftTypography component="span" fontSize="16px" fontWeight="bold">
          {title},{" "}
        </SoftTypography>
        {subtitle}
      </SoftTypography>
    </SoftBox>

    {inspectionType && (
      <SoftBox display="flex" gap={0.5}>
        <SoftTypography fontSize="14px" fontWeight="regular" color="text">
          Inspection Type:
        </SoftTypography>
        <SoftTypography fontSize="14px" fontWeight="regular" color="lightBlack">
          {inspectionType}
        </SoftTypography>
      </SoftBox>
    )}

    {comments && (
      <SoftBox>
        <SoftTypography fontSize="14px" fontWeight="regular" color="text">
          Comments
        </SoftTypography>

        {comments?.split("\n")?.map((comment, index) => (
          <SoftTypography
            fontSize="14px"
            fontWeight="regular"
            color="lightBlack"
          >
            {comment}
          </SoftTypography>
        ))}
      </SoftBox>
    )}

    {PifNumber?.type && (
      <SoftBox display="flex" gap={0.5} backgroundColor="shadow.main">
        <SoftTypography fontSize="14px" fontWeight="regular" color="text">
          {PifNumber?.type == "corrected_pif"
            ? "PIF Corrected Number :"
            : "PIF Replace Number :"}
        </SoftTypography>

        <SoftBox backgroundColor="#F8FE01" px={5}>
          <SoftTypography
            fontSize="14px"
            fontWeight="regular"
            color="lightBlack"
          >
            {PifNumber?.value}
          </SoftTypography>
        </SoftBox>
      </SoftBox>
    )}

    {notes && (
      <SoftBox>
        <SoftTypography fontSize="14px" fontWeight="regular" color="text">
          Notes
        </SoftTypography>
        {notes?.split("\n")?.map((note, index) => (
          <SoftTypography
            fontSize="14px"
            fontWeight="regular"
            color="lightBlack"
          >
            {note}
          </SoftTypography>
        ))}
      </SoftBox>
    )}

    {images?.length !== 0 && (
      <SoftBox display="flex" alignItems="center" gap={1} flexWrap="wrap">
        {images?.map((image, index) => (
          <Link to={image} target="_blank">
            <SoftBox position="relative" mt={1}>
              <SoftBox
                key={index}
                component="img"
                src={image}
                sx={{
                  width: 80,
                  height: 80,
                  objectFit: "cover",
                  borderRadius: "12px",
                  border: "0.63px solid #02255B",
                }}
              />
            </SoftBox>
          </Link>
        ))}
      </SoftBox>
    )}
  </SoftBox>
);
